export default "__VITE_ASSET__65b78125__"